// Copyright (c) Ensho Health, 2021 to present

import client from './client-http.js';

export async function sendHeartbeat(info = {}) {
  try {
    const url = window.location.href;
    await client.post('/heartbeat', { url: url, ...info });
  } catch (error) {
    if (error.response.status >= 400 && error.response.status < 500) {
      throw new Error('LOGOUT');
    } else {
      console.error('heartbeat.api.sendHearbeat: ' + error.response.status);
      throw new Error('something went wrong while sending a heartbeat');
    }
  }
}
